import { LEADS_PERMISSION_ID } from '../../constants/leadScan';

export function isEventLeadsEnabled(event) {
    return event?.permissions?.some((perm) => perm.permission == LEADS_PERMISSION_ID);
}
